import { AxiosError } from 'axios';
import React, { useMemo } from 'react';
import Alert from 'react-bootstrap/Alert';
import { Button } from 'react-bootstrap';

interface ErrorFallbackProps {
  error: string | Error | AxiosError | unknown;
}

const ErrorFallback = ({ error }: ErrorFallbackProps) => {
  const message = useMemo(() => {
    if (typeof error === 'string') {
      return error;
    }
    if (error instanceof AxiosError) {
      return error.response?.data?.message || error.message;
    }
    return error instanceof Error
      ? error.message
      : 'An unexpected error occurred';
  }, [error]);

  return (
    <Alert variant='danger'>
      <Alert.Heading>Error</Alert.Heading>
      <p>{message}</p>
    </Alert>
  );
};

export default ErrorFallback;
